import React from "react";
import { ToastContainer } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock } from "@fortawesome/free-solid-svg-icons";

import logoImage from "../../images/LandingPageImage/Isancharr.svg";
import useAdminLogin from "../../services/Admin/useAdminLogin";

const AdminLogin = () => {
  const {
    mobileNumber,
    setMobileNumber,

    password,
    setPassword,

    otp,
    setOtp,

    isOTPVisible,

    loading,

    handleSubmit,
    handleOTPSubmit,
    goBackToLogin,
  } = useAdminLogin();

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-[#0052D4] via-[#4364F7] to-[#6FB1FC] p-5">
        <div className="relative w-full max-w-[450px] overflow-hidden rounded-[20px] bg-white/95 p-8 shadow-[0_10px_30px_rgba(0,0,0,0.1)] transition-all duration-300">
          {/* Logo */}
          <div className="mx-auto mb-8 flex h-[100px] w-[100px] animate-[logoFloat_3s_ease-in-out_infinite] items-center justify-center rounded-[20px] text-2xl font-bold text-white">
            <img src={logoImage} alt="Logo" className="w-full" />
          </div>

          {/* Header */}
          <div className="mb-6 text-center">
            <h2 className="mb-2 text-[28px] font-bold text-gray-900">
              Admin Login
            </h2>

            <p className="text-[15px] text-gray-500">
              Welcome back! Please enter your details.
            </p>
          </div>

          {!isOTPVisible ? (
            <form
              onSubmit={handleSubmit}
              className="animate-[slideUp_0.5s_ease_forwards]"
            >
              <label className="mb-2 block text-[15px] font-semibold text-gray-700">
                Mobile Number
              </label>

              <div className="relative mb-6">
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className="absolute left-[15px] top-1/2 z-10 -translate-y-1/2 text-gray-500"
                />

                <input
                  type="tel"
                  value={mobileNumber}
                  onChange={(e) =>
                    setMobileNumber(e.target.value.replace(/[^0-9]/g, ""))
                  }
                  placeholder="Enter your mobile number"
                  className="h-[55px] w-full rounded-xl border-2 border-gray-200 bg-white pl-[45px] pr-4 text-[15px] font-medium text-gray-800 outline-none transition placeholder:font-normal placeholder:text-gray-400 focus:border-[#4364F7] focus:ring-4 focus:ring-[#4364F7]/10"
                />
              </div>

              <label className="mb-2 block text-[15px] font-semibold text-gray-700">
                Password
              </label>

              <div className="relative mb-6">
                <FontAwesomeIcon
                  icon={faLock}
                  className="absolute left-[15px] top-1/2 z-10 -translate-y-1/2 text-gray-500"
                />

                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  className="h-[55px] w-full rounded-xl border-2 border-gray-200 bg-white pl-[45px] pr-4 text-[15px] font-medium text-gray-800 outline-none transition placeholder:font-normal placeholder:text-gray-400 focus:border-[#4364F7] focus:ring-4 focus:ring-[#4364F7]/10"
                />
              </div>

              <div className="mb-6 flex items-center justify-between">
                <label className="flex cursor-pointer items-center gap-2 text-[14px] text-gray-500">
                  <input
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 accent-[#4364F7]"
                  />
                  Remember me
                </label>

                <a
                  href="#"
                  className="text-[14px] font-medium text-[#4364F7] transition hover:text-[#0052D4]"
                >
                  Forgot password?
                </a>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="relative h-[50px] w-full overflow-hidden rounded-xl bg-gradient-to-r from-[#0052D4] to-[#4364F7] font-semibold text-white transition duration-300 hover:-translate-y-[2px] hover:shadow-[0_5px_15px_rgba(67,100,247,0.4)] disabled:cursor-not-allowed disabled:opacity-70"
              >
                {loading ? "Please wait..." : "Continue"}
              </button>
            </form>
          ) : (
            <form
              onSubmit={handleOTPSubmit}
              className="animate-[slideDown_0.5s_ease_forwards]"
            >
              <label className="mb-2 block text-[15px] font-semibold text-gray-700">
                Enter OTP
              </label>

              <div className="relative mb-3">
                <input
                  type="text"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
                  placeholder="Enter 6-digit OTP"
                  maxLength={6}
                  className="h-[55px] w-full rounded-xl border-2 border-gray-200 bg-white px-4 text-center text-[18px] font-bold tracking-[8px] text-gray-800 outline-none transition placeholder:text-[15px] placeholder:font-normal placeholder:tracking-normal placeholder:text-gray-400 focus:border-[#4364F7] focus:ring-4 focus:ring-[#4364F7]/10"
                />
              </div>

              <p className="mt-2 text-center text-[14px] text-gray-500">
                OTP has been sent to your registered mobile number
              </p>

              <div className="mt-6 flex items-center justify-between">
                <button
                  type="button"
                  onClick={goBackToLogin}
                  disabled={loading}
                  className="bg-transparent p-0 font-semibold text-[#4364F7] transition hover:-translate-x-1 hover:text-[#0052D4] disabled:cursor-not-allowed disabled:opacity-60"
                >
                  ← Back to login
                </button>

                <button
                  type="submit"
                  disabled={loading}
                  className="h-[44px] w-[120px] rounded-xl bg-gradient-to-r from-[#0052D4] to-[#4364F7] text-sm font-semibold text-white transition hover:-translate-y-[2px] hover:shadow-[0_5px_15px_rgba(67,100,247,0.4)] disabled:cursor-not-allowed disabled:opacity-70"
                >
                  {loading ? "..." : "Verify OTP"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>

      <style>
        {`
          @keyframes logoFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }

          @keyframes slideUp {
            from { transform: translateY(20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }

          @keyframes slideDown {
            from { transform: translateY(-20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </>
  );
};

export default AdminLogin;